import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, throttleTime } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MenuService } from '../../../core/services/menu.service';
import { GlobalMenuItem, User } from '../../../domains/index';

@Component({
  selector: 'app-global-menu',
  templateUrl: './global-menu.component.html',
  standalone: false,
})
export class GlobalMenuComponent implements OnInit, OnDestroy {
  readonly #menuService = inject(MenuService);

  @Input() user: User;
  globalMenuData: GlobalMenuItem[] = [];
  isOpenMenu = false;
  homeUrl = environment.home_url;

  private fetchGlobalMenuListRequest$ = new Subject<void>();
  private onDestroy$ = new Subject<void>();

  ngOnInit() {
    this.fetchGlobalMenuListRequest$.pipe(throttleTime(1000), takeUntil(this.onDestroy$)).subscribe(() => {
      if (this.globalMenuData.length > 0) {
        this.isOpenMenu = true;
        return;
      }
      this.#menuService.getMenu().subscribe((menuItemList) => {
        this.globalMenuData = menuItemList;
        this.isOpenMenu = true;
      });
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  toggleMenu(): void {
    if (this.isOpenMenu) {
      this.closeMenu();
    } else {
      this.showMenu();
    }
  }

  showMenu(): void {
    this.fetchGlobalMenuListRequest$.next();
  }

  closeMenu(): void {
    this.isOpenMenu = false;
  }
}
